import { DropdownChoice } from '@/utils/businessAppApi';
import { ChoiceType } from './types';

// Helper functions for type-safe dropdown option handling
export const isEnhancedChoice = (choice: ChoiceType): choice is DropdownChoice => {
  return typeof choice === 'object' && 'value' in choice;
};

export const getChoiceValue = (choice: ChoiceType): string => {
  return isEnhancedChoice(choice) ? choice.value : choice;
};

export const ensureStringArray = (options: string[] | DropdownChoice[] | undefined): string[] => {
  if (!options) return [];
  return options.map(opt => getChoiceValue(opt));
};

export const ensureEnhancedArray = (options: string[] | DropdownChoice[] | undefined): DropdownChoice[] => {
  if (!options) return [];
  return options.map(opt => isEnhancedChoice(opt) ? opt : { value: opt });
}; 